import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';

import {
  stringInputSpec,
  stringSelectSpec,
  boolCheckboxSpec,
  repeatable,
} from '../../lib/editing-configs';

const InsuranceProductCardWrapper = ({
  buttonText,
  buttonAnnotation,
  bannerCalloutText,
  bannerCalloutType,
  bottomLineBlurb,
  marketplaceEntityId,
  prosBullets,
  prosBulletsObj,
  consBullets,
  consBulletsObj,
  tagline,
  subProductType,
  redirectToPartner,
  renderWhyPickedTab,
  simplified,
  number,
}) => {
  // eslint-disable-next-line no-param-reassign
  prosBullets =
    Object.keys(prosBulletsObj).length === 0
      ? undefined
      : prosBulletsObj?.map(function (obj) {
          return obj.text;
        });

  // eslint-disable-next-line no-param-reassign
  consBullets =
    Object.keys(consBulletsObj).length === 0
      ? undefined
      : consBulletsObj?.map(function (obj) {
          return obj.text;
        });

  return (
    <StructuredContent>
      {{
        type: 'InsuranceProductCard',
        version: '1.0.0',
        props: {
          buttonText,
          buttonAnnotation,
          bannerCalloutText,
          bannerCalloutType,
          bottomLineBlurb,
          marketplaceEntityId,
          prosBullets,
          consBullets,
          tagline,
          subProductType,
          redirectToPartner,
          renderWhyPickedTab,
          simplified,
          number,
        },
      }}
    </StructuredContent>
  );
};

const InsuranceSubProductType = {
  AUTO: 'Auto',
  HOME: 'Home',
  LIFE: 'Life',
};

InsuranceProductCardWrapper.propTypes = {
  buttonText: PropTypes.string,
  buttonAnnotation: PropTypes.string,
  bannerCalloutText: PropTypes.string,
  bannerCalloutType: PropTypes.string,
  bottomLineBlurb: PropTypes.string,
  marketplaceEntityId: PropTypes.string,
  prosBulletsObj: PropTypes.object,
  consBulletsObj: PropTypes.object,
  prosBullets: PropTypes.arrayOf(PropTypes.string) || '',
  consBullets: PropTypes.arrayOf(PropTypes.string) || '',
  tagline: PropTypes.string,
  subProductType: PropTypes.string,
  redirectToPartner: PropTypes.bool,
  renderWhyPickedTab: PropTypes.bool,
  simplified: PropTypes.bool,
  number: PropTypes.string,
};

InsuranceProductCardWrapper.defaultProps = {
  buttonText: 'Compare My Rates',
  marketplaceEntityId: 'f2471ba2-733b-11e9-9778-9b7965868376',
  subProductType: InsuranceSubProductType.AUTO,
  prosBulletsObj: [],
  consBulletsObj: [],
};

InsuranceProductCardWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('buttonText', 'Button Text'),
    stringInputSpec('buttonAnnotation', 'Button Annotation'),
    stringInputSpec('bannerCalloutText', 'Banner Callout Text'),
    stringSelectSpec('bannerCalloutType', 'Banner Callout Type', [
      { label: 'Info', value: 'default' },
      { label: 'Best Of', value: 'best_of' },
      { label: 'Warning', value: 'emergency' },
    ]),
    stringInputSpec('bottomLineBlurb', 'Bottom Line Blurb'),
    stringInputSpec('marketplaceEntityId', 'Marketplace Entity ID'),
    repeatable('prosBulletsObj', 'ProsBullets', 'prosBullet', () => [
      stringInputSpec('text', 'Text'),
    ]),
    repeatable('consBulletsObj', 'ConsBullets', 'ConsBullet', () => [
      stringInputSpec('text', 'Text'),
    ]),
    stringInputSpec('tagline', 'Tagline'),
    stringSelectSpec('subProductType', 'SubProduct Type', [
      { label: 'Auto', value: InsuranceSubProductType.AUTO },
      { label: 'Home', value: InsuranceSubProductType.HOME },
      { label: 'Life', value: InsuranceSubProductType.LIFE },
    ]),
    boolCheckboxSpec('redirectToPartner', 'Redirect to Partner'),
    boolCheckboxSpec('renderWhyPickedTab', 'Render Why Picked Tab'),
    boolCheckboxSpec('simplified', 'Simplified'),
    stringInputSpec('number', 'Number'),
  ];
};

InsuranceProductCardWrapper.displayName = 'InsuranceProductCardWrapper';

export default InsuranceProductCardWrapper;
